import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3c99f314 = () => interopDefault(import('../../../pages/404-error/index.vue' /* webpackChunkName: "pages/404-error/index" */))
const _5c129302 = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _bfe9523a = () => interopDefault(import('../../../pages/builder-data-reports/index.vue' /* webpackChunkName: "pages/builder-data-reports/index" */))
const _431e5cba = () => interopDefault(import('../../../pages/buy-sell-your-home/index.vue' /* webpackChunkName: "pages/buy-sell-your-home/index" */))
const _24f187d3 = () => interopDefault(import('../../../pages/buy-your-home/index.vue' /* webpackChunkName: "pages/buy-your-home/index" */))
const _5fc58cda = () => interopDefault(import('../../../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _0207c2c8 = () => interopDefault(import('../../../pages/commissions-calculator/index.vue' /* webpackChunkName: "pages/commissions-calculator/index" */))
const _465d808c = () => interopDefault(import('../../../pages/comparables/index.vue' /* webpackChunkName: "pages/comparables/index" */))
const _7b801741 = () => interopDefault(import('../../../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _261db5b7 = () => interopDefault(import('../../../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _375d7482 = () => interopDefault(import('../../../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _fb2b6e62 = () => interopDefault(import('../../../pages/list-home/index.vue' /* webpackChunkName: "pages/list-home/index" */))
const _01e5bb81 = () => interopDefault(import('../../../pages/listing-management/index.vue' /* webpackChunkName: "pages/listing-management/index" */))
const _eb25366c = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _2213a4fc = () => interopDefault(import('../../../pages/market-data/index.vue' /* webpackChunkName: "pages/market-data/index" */))
const _4734f3be = () => interopDefault(import('../../../pages/messages/index.vue' /* webpackChunkName: "pages/messages/index" */))
const _5d5e4bf9 = () => interopDefault(import('../../../pages/my-abode-overview/index.vue' /* webpackChunkName: "pages/my-abode-overview/index" */))
const _15e0c991 = () => interopDefault(import('../../../pages/my-listings/index.vue' /* webpackChunkName: "pages/my-listings/index" */))
const _484f1662 = () => interopDefault(import('../../../pages/offer-management-buyer/index.vue' /* webpackChunkName: "pages/offer-management-buyer/index" */))
const _1cc84c39 = () => interopDefault(import('../../../pages/offer-management-seller/index.vue' /* webpackChunkName: "pages/offer-management-seller/index" */))
const _636809a8 = () => interopDefault(import('../../../pages/offers/index.vue' /* webpackChunkName: "pages/offers/index" */))
const _23bff4a9 = () => interopDefault(import('../../../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _cbe36f02 = () => interopDefault(import('../../../pages/pro-edit/index.vue' /* webpackChunkName: "pages/pro-edit/index" */))
const _3e4fa2e8 = () => interopDefault(import('../../../pages/pro-marketplace/index.vue' /* webpackChunkName: "pages/pro-marketplace/index" */))
const _8e8f77c6 = () => interopDefault(import('../../../pages/pro-search/index.vue' /* webpackChunkName: "pages/pro-search/index" */))
const _5f5a6260 = () => interopDefault(import('../../../pages/request-sticker/index.vue' /* webpackChunkName: "pages/request-sticker/index" */))
const _5663e406 = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _5e3a3c53 = () => interopDefault(import('../../../pages/sell-your-home/index.vue' /* webpackChunkName: "pages/sell-your-home/index" */))
const _01f4e526 = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _813aea38 = () => interopDefault(import('../../../pages/sold-data/index.vue' /* webpackChunkName: "pages/sold-data/index" */))
const _0f84df4c = () => interopDefault(import('../../../pages/terms-of-service/index.vue' /* webpackChunkName: "pages/terms-of-service/index" */))
const _e968eeae = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _e5b674c6 = () => interopDefault(import('../../../pages/whoweare/index.vue' /* webpackChunkName: "pages/whoweare/index" */))
const _5d44ac88 = () => interopDefault(import('../../../pages/why-bode/index.vue' /* webpackChunkName: "pages/why-bode/index" */))
const _c7788aaa = () => interopDefault(import('../../../pages/admin/builder-report-management/index.vue' /* webpackChunkName: "pages/admin/builder-report-management/index" */))
const _75f2bed8 = () => interopDefault(import('../../../pages/admin/conversation/index.vue' /* webpackChunkName: "pages/admin/conversation/index" */))
const _3397fc69 = () => interopDefault(import('../../../pages/admin/offer-management/index.vue' /* webpackChunkName: "pages/admin/offer-management/index" */))
const _518fa6e3 = () => interopDefault(import('../../../pages/admin/showings/index.vue' /* webpackChunkName: "pages/admin/showings/index" */))
const _147f3816 = () => interopDefault(import('../../../pages/listings/review.vue' /* webpackChunkName: "pages/listings/review" */))
const _971d1c20 = () => interopDefault(import('../../../pages/login/idp/index.vue' /* webpackChunkName: "pages/login/idp/index" */))
const _39622fec = () => interopDefault(import('../../../pages/login/reset/index.vue' /* webpackChunkName: "pages/login/reset/index" */))
const _8af29832 = () => interopDefault(import('../../../pages/offers/submit-success/index.vue' /* webpackChunkName: "pages/offers/submit-success/index" */))
const _51f9ae03 = () => interopDefault(import('../../../pages/offers/summary/index.vue' /* webpackChunkName: "pages/offers/summary/index" */))
const _77527299 = () => interopDefault(import('../../../pages/pro-edit/profile/index.vue' /* webpackChunkName: "pages/pro-edit/profile/index" */))
const _49d05eb6 = () => interopDefault(import('../../../pages/pro-edit/service/index.vue' /* webpackChunkName: "pages/pro-edit/service/index" */))
const _46a16f36 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/index" */))
const _88942c74 = () => interopDefault(import('../../../pages/pro-marketplace/pro-login/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-login/index" */))
const _693ab376 = () => interopDefault(import('../../../pages/pro-marketplace/pro-portal/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-portal/index" */))
const _100dddf4 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/index" */))
const _0441cfd6 = () => interopDefault(import('../../../pages/pro-marketplace/service-requests/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-requests/index" */))
const _ec8ff1ea = () => interopDefault(import('../../../pages/search/saved-search-list/index.vue' /* webpackChunkName: "pages/search/saved-search-list/index" */))
const _790ad5be = () => interopDefault(import('../../../pages/signup/additional-information/index.vue' /* webpackChunkName: "pages/signup/additional-information/index" */))
const _8ef9d444 = () => interopDefault(import('../../../pages/signup/confirm/index.vue' /* webpackChunkName: "pages/signup/confirm/index" */))
const _1991aae6 = () => interopDefault(import('../../../pages/admin/listings/import/index.vue' /* webpackChunkName: "pages/admin/listings/import/index" */))
const _6e67530a = () => interopDefault(import('../../../pages/admin/listings/update/index.vue' /* webpackChunkName: "pages/admin/listings/update/index" */))
const _48bec9db = () => interopDefault(import('../../../pages/ds/callback/listing/index.vue' /* webpackChunkName: "pages/ds/callback/listing/index" */))
const _79974a9a = () => interopDefault(import('../../../pages/ds/callback/offer/index.vue' /* webpackChunkName: "pages/ds/callback/offer/index" */))
const _2c12f861 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index" */))
const _3f481478 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/photography-measurements/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/photography-measurements/index" */))
const _503e023f = () => interopDefault(import('../../../pages/admin/listings/update/form/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/index" */))
const _3f2e7209 = () => interopDefault(import('../../../pages/admin/listings/update/table/index.vue' /* webpackChunkName: "pages/admin/listings/update/table/index" */))
const _0d2f32de = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index" */))
const _0a3bff20 = () => interopDefault(import('../../../pages/admin/listings/update/form/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/form/constants/index" */))
const _57e689f3 = () => interopDefault(import('../../../pages/admin/listings/update/form/controls/index.js' /* webpackChunkName: "pages/admin/listings/update/form/controls/index" */))
const _b61779bc = () => interopDefault(import('../../../pages/admin/listings/update/form/listing-item/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/listing-item/index" */))
const _43cbbbcd = () => interopDefault(import('../../../pages/admin/listings/update/services/AdminUpdateListingTableMapService.js' /* webpackChunkName: "pages/admin/listings/update/services/AdminUpdateListingTableMapService" */))
const _3be6233a = () => interopDefault(import('../../../pages/admin/listings/update/table/checkbox-cell.vue' /* webpackChunkName: "pages/admin/listings/update/table/checkbox-cell" */))
const _73f1b3e6 = () => interopDefault(import('../../../pages/admin/listings/update/table/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/table/constants/index" */))
const _620add83 = () => interopDefault(import('../../../pages/admin/listings/update/table/enums/index.js' /* webpackChunkName: "pages/admin/listings/update/table/enums/index" */))
const _1ad3aa34 = () => interopDefault(import('../../../pages/admin/listings/update/table/header.vue' /* webpackChunkName: "pages/admin/listings/update/table/header" */))
const _6a71c3c3 = () => interopDefault(import('../../../pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps.js' /* webpackChunkName: "pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps" */))
const _79d6d391 = () => interopDefault(import('../../../pages/pro-marketplace/profile/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/profile/_id/index" */))
const _69cad86a = () => interopDefault(import('../../../pages/pro-marketplace/view-request/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/view-request/_id/index" */))
const _2d7ed88c = () => interopDefault(import('../../../pages/buyer-checklist/_page/index.vue' /* webpackChunkName: "pages/buyer-checklist/_page/index" */))
const _3d3939bd = () => interopDefault(import('../../../pages/how-it-works/_id/index.vue' /* webpackChunkName: "pages/how-it-works/_id/index" */))
const _191b9eca = () => interopDefault(import('../../../pages/listing-editing/_id/index.vue' /* webpackChunkName: "pages/listing-editing/_id/index" */))
const _de85f722 = () => interopDefault(import('../../../pages/listings/_id/index.vue' /* webpackChunkName: "pages/listings/_id/index" */))
const _967a9f0e = () => interopDefault(import('../../../pages/pro/_id/index.vue' /* webpackChunkName: "pages/pro/_id/index" */))
const _41e9e5e8 = () => interopDefault(import('../../../pages/seller-checklist/_page/index.vue' /* webpackChunkName: "pages/seller-checklist/_page/index" */))
const _ae60c19a = () => interopDefault(import('../../../pages/settings/_section/index.vue' /* webpackChunkName: "pages/settings/_section/index" */))
const _9cd5998c = () => interopDefault(import('../../../pages/sold-property/_id/index.vue' /* webpackChunkName: "pages/sold-property/_id/index" */))
const _e340946a = () => interopDefault(import('../../../pages/user/_id/index.vue' /* webpackChunkName: "pages/user/_id/index" */))
const _14f3377b = () => interopDefault(import('../../../pages/listings/_id/audit/index.vue' /* webpackChunkName: "pages/listings/_id/audit/index" */))
const _16638874 = () => interopDefault(import('../../../pages/listings/_id/dashboard/index.vue' /* webpackChunkName: "pages/listings/_id/dashboard/index" */))
const _5c20c778 = () => interopDefault(import('../../../pages/listings/_id/submit-success/index.vue' /* webpackChunkName: "pages/listings/_id/submit-success/index" */))
const _326d4ace = () => interopDefault(import('../../../pages/settings/_section/enums/index.js' /* webpackChunkName: "pages/settings/_section/enums/index" */))
const _2c00444a = () => interopDefault(import('../../../pages/listings/_id/dashboard/enums.js' /* webpackChunkName: "pages/listings/_id/dashboard/enums" */))
const _654aac36 = () => interopDefault(import('../../../pages/listings/_id/viewings/_type/index.vue' /* webpackChunkName: "pages/listings/_id/viewings/_type/index" */))
const _889b6052 = () => interopDefault(import('../../../pages/users/_id/_section/index.vue' /* webpackChunkName: "pages/users/_id/_section/index" */))
const _75733c70 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404-error",
    component: _3c99f314,
    name: "404-error"
  }, {
    path: "/app",
    component: _5c129302,
    name: "app"
  }, {
    path: "/builder-data-reports",
    component: _bfe9523a,
    name: "builder-data-reports"
  }, {
    path: "/buy-sell-your-home",
    component: _431e5cba,
    name: "buy-sell-your-home"
  }, {
    path: "/buy-your-home",
    component: _24f187d3,
    name: "buy-your-home"
  }, {
    path: "/calendar",
    component: _5fc58cda,
    name: "calendar"
  }, {
    path: "/commissions-calculator",
    component: _0207c2c8,
    name: "commissions-calculator"
  }, {
    path: "/comparables",
    component: _465d808c,
    name: "comparables"
  }, {
    path: "/contact",
    component: _7b801741,
    name: "contact"
  }, {
    path: "/faq",
    component: _261db5b7,
    name: "faq"
  }, {
    path: "/favourites",
    component: _375d7482,
    name: "favourites"
  }, {
    path: "/list-home",
    component: _fb2b6e62,
    name: "list-home"
  }, {
    path: "/listing-management",
    component: _01e5bb81,
    name: "listing-management"
  }, {
    path: "/login",
    component: _eb25366c,
    name: "login"
  }, {
    path: "/market-data",
    component: _2213a4fc,
    name: "market-data"
  }, {
    path: "/messages",
    component: _4734f3be,
    name: "messages"
  }, {
    path: "/my-abode-overview",
    component: _5d5e4bf9,
    name: "my-abode-overview"
  }, {
    path: "/my-listings",
    component: _15e0c991,
    name: "my-listings"
  }, {
    path: "/offer-management-buyer",
    component: _484f1662,
    name: "offer-management-buyer"
  }, {
    path: "/offer-management-seller",
    component: _1cc84c39,
    name: "offer-management-seller"
  }, {
    path: "/offers",
    component: _636809a8,
    name: "offers"
  }, {
    path: "/privacy",
    component: _23bff4a9,
    name: "privacy"
  }, {
    path: "/pro-edit",
    component: _cbe36f02,
    name: "pro-edit"
  }, {
    path: "/pro-marketplace",
    component: _3e4fa2e8,
    name: "pro-marketplace"
  }, {
    path: "/pro-search",
    component: _8e8f77c6,
    name: "pro-search"
  }, {
    path: "/request-sticker",
    component: _5f5a6260,
    name: "request-sticker"
  }, {
    path: "/search",
    component: _5663e406,
    name: "search"
  }, {
    path: "/sell-your-home",
    component: _5e3a3c53,
    name: "sell-your-home"
  }, {
    path: "/signup",
    component: _01f4e526,
    name: "signup"
  }, {
    path: "/sold-data",
    component: _813aea38,
    name: "sold-data"
  }, {
    path: "/terms-of-service",
    component: _0f84df4c,
    name: "terms-of-service"
  }, {
    path: "/users",
    component: _e968eeae,
    name: "users"
  }, {
    path: "/whoweare",
    component: _e5b674c6,
    name: "whoweare"
  }, {
    path: "/why-bode",
    component: _5d44ac88,
    name: "why-bode"
  }, {
    path: "/admin/builder-report-management",
    component: _c7788aaa,
    name: "admin-builder-report-management"
  }, {
    path: "/admin/conversation",
    component: _75f2bed8,
    name: "admin-conversation"
  }, {
    path: "/admin/offer-management",
    component: _3397fc69,
    name: "admin-offer-management"
  }, {
    path: "/admin/showings",
    component: _518fa6e3,
    name: "admin-showings"
  }, {
    path: "/listings/review",
    component: _147f3816,
    name: "listings-review"
  }, {
    path: "/login/idp",
    component: _971d1c20,
    name: "login-idp"
  }, {
    path: "/login/reset",
    component: _39622fec,
    name: "login-reset"
  }, {
    path: "/offers/submit-success",
    component: _8af29832,
    name: "offers-submit-success"
  }, {
    path: "/offers/summary",
    component: _51f9ae03,
    name: "offers-summary"
  }, {
    path: "/pro-edit/profile",
    component: _77527299,
    name: "pro-edit-profile"
  }, {
    path: "/pro-edit/service",
    component: _49d05eb6,
    name: "pro-edit-service"
  }, {
    path: "/pro-marketplace/marketplace-for-pros",
    component: _46a16f36,
    name: "pro-marketplace-marketplace-for-pros"
  }, {
    path: "/pro-marketplace/pro-login",
    component: _88942c74,
    name: "pro-marketplace-pro-login"
  }, {
    path: "/pro-marketplace/pro-portal",
    component: _693ab376,
    name: "pro-marketplace-pro-portal"
  }, {
    path: "/pro-marketplace/service-request",
    component: _100dddf4,
    name: "pro-marketplace-service-request"
  }, {
    path: "/pro-marketplace/service-requests",
    component: _0441cfd6,
    name: "pro-marketplace-service-requests"
  }, {
    path: "/search/saved-search-list",
    component: _ec8ff1ea,
    name: "search-saved-search-list"
  }, {
    path: "/signup/additional-information",
    component: _790ad5be,
    name: "signup-additional-information"
  }, {
    path: "/signup/confirm",
    component: _8ef9d444,
    name: "signup-confirm"
  }, {
    path: "/admin/listings/import",
    component: _1991aae6,
    name: "admin-listings-import"
  }, {
    path: "/admin/listings/update",
    component: _6e67530a,
    name: "admin-listings-update"
  }, {
    path: "/ds/callback/listing",
    component: _48bec9db,
    name: "ds-callback-listing"
  }, {
    path: "/ds/callback/offer",
    component: _79974a9a,
    name: "ds-callback-offer"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up",
    component: _2c12f861,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up"
  }, {
    path: "/pro-marketplace/service-request/photography-measurements",
    component: _3f481478,
    name: "pro-marketplace-service-request-photography-measurements"
  }, {
    path: "/admin/listings/update/form",
    component: _503e023f,
    name: "admin-listings-update-form"
  }, {
    path: "/admin/listings/update/table",
    component: _3f2e7209,
    name: "admin-listings-update-table"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up/successful",
    component: _0d2f32de,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up-successful"
  }, {
    path: "/admin/listings/update/form/constants",
    component: _0a3bff20,
    name: "admin-listings-update-form-constants"
  }, {
    path: "/admin/listings/update/form/controls",
    component: _57e689f3,
    name: "admin-listings-update-form-controls"
  }, {
    path: "/admin/listings/update/form/listing-item",
    component: _b61779bc,
    name: "admin-listings-update-form-listing-item"
  }, {
    path: "/admin/listings/update/services/AdminUpdateListingTableMapService",
    component: _43cbbbcd,
    name: "admin-listings-update-services-AdminUpdateListingTableMapService"
  }, {
    path: "/admin/listings/update/table/checkbox-cell",
    component: _3be6233a,
    name: "admin-listings-update-table-checkbox-cell"
  }, {
    path: "/admin/listings/update/table/constants",
    component: _73f1b3e6,
    name: "admin-listings-update-table-constants"
  }, {
    path: "/admin/listings/update/table/enums",
    component: _620add83,
    name: "admin-listings-update-table-enums"
  }, {
    path: "/admin/listings/update/table/header",
    component: _1ad3aa34,
    name: "admin-listings-update-table-header"
  }, {
    path: "/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps",
    component: _6a71c3c3,
    name: "admin-listings-update-table-mixins-AdminListingsUpdateTableRowsProps"
  }, {
    path: "/pro-marketplace/profile/:id",
    component: _79d6d391,
    name: "pro-marketplace-profile-id"
  }, {
    path: "/pro-marketplace/view-request/:id",
    component: _69cad86a,
    name: "pro-marketplace-view-request-id"
  }, {
    path: "/buyer-checklist/:page",
    component: _2d7ed88c,
    name: "buyer-checklist-page"
  }, {
    path: "/how-it-works/:id",
    component: _3d3939bd,
    name: "how-it-works-id"
  }, {
    path: "/listing-editing/:id",
    component: _191b9eca,
    name: "listing-editing-id"
  }, {
    path: "/listings/:id",
    component: _de85f722,
    name: "listings-id"
  }, {
    path: "/pro/:id",
    component: _967a9f0e,
    name: "pro-id"
  }, {
    path: "/seller-checklist/:page",
    component: _41e9e5e8,
    name: "seller-checklist-page"
  }, {
    path: "/settings/:section",
    component: _ae60c19a,
    name: "settings-section"
  }, {
    path: "/sold-property/:id",
    component: _9cd5998c,
    name: "sold-property-id"
  }, {
    path: "/user/:id",
    component: _e340946a,
    name: "user-id"
  }, {
    path: "/listings/:id?/audit",
    component: _14f3377b,
    name: "listings-id-audit"
  }, {
    path: "/listings/:id?/dashboard",
    component: _16638874,
    name: "listings-id-dashboard"
  }, {
    path: "/listings/:id?/submit-success",
    component: _5c20c778,
    name: "listings-id-submit-success"
  }, {
    path: "/settings/:section?/enums",
    component: _326d4ace,
    name: "settings-section-enums"
  }, {
    path: "/listings/:id?/dashboard/enums",
    component: _2c00444a,
    name: "listings-id-dashboard-enums"
  }, {
    path: "/listings/:id?/viewings/:type",
    component: _654aac36,
    name: "listings-id-viewings-type"
  }, {
    path: "/users/:id/:section",
    component: _889b6052,
    name: "users-id-section"
  }, {
    path: "/",
    component: _75733c70,
    name: "index"
  }, {
    path: "/buyer-checklist",
    redirect: "/buyer-checklist/getting-ready",
    name: "/buyer-checklist"
  }, {
    path: "/how-it-works",
    redirect: "/how-it-works/seller",
    name: "/how-it-works"
  }, {
    path: "/howitworks",
    redirect: "/how-it-works/seller",
    name: "/howitworks"
  }, {
    path: "/listings",
    redirect: "/search",
    name: "/listings"
  }, {
    path: "/listings/:city/:community/:propertyType/:price/:id",
    redirect: "/listings/:id",
    name: "/listings/:city/:community/:propertyType/:price/:id"
  }, {
    path: "/logout",
    redirect: "/",
    name: "/logout"
  }, {
    path: "/error404",
    redirect: "/404-error",
    name: "/error404"
  }, {
    path: "/pro-:id-:companyname",
    redirect: "/pro/:id",
    name: "/pro-:id-:companyname"
  }, {
    path: "/profiles/:id",
    redirect: "/users/:id",
    name: "/profiles/:id"
  }, {
    path: "/seller-checklist",
    redirect: "/seller-checklist/getting-ready",
    name: "/seller-checklist"
  }, {
    path: "/start-listing",
    redirect: "/sell-your-home",
    name: "/start-listing"
  }, {
    path: "/terms",
    redirect: "/terms-of-service",
    name: "/terms"
  }, {
    path: "/whybode",
    redirect: "/why-bode",
    name: "/whybode"
  }, {
    path: "/who-we-are",
    redirect: "/whoweare",
    name: "/who-we-are"
  }, {
    path: "/offers/seller",
    redirect: "/offer-management-seller",
    name: "/offers/seller"
  }, {
    path: "/offers/buyer",
    redirect: "/offer-management-buyer",
    name: "/offers/buyer"
  }, {
    path: "/documents",
    redirect: "/offer-management-seller",
    name: "/documents"
  }, {
    path: "/list-your-home",
    redirect: "/list-home",
    name: "/list-your-home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
